import React from 'react';
import Axios from 'axios';
import moment from 'moment';

class AddSubseason extends React.Component {

  constructor(props) {
		super(props);
		this.state = {
 			seasonId: this.props.seasonId,
 			ssid: this.props.ssid,
			startDate: '',
			subseasonName: ''
		};
	
		this.setProps = this.setProps.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSeasonNameChange = this.handleSeasonNameChange.bind(this);
		this.handleStartDateChange = this.handleStartDateChange.bind(this);
	}

 	componentDidMount() {
		//console.log('AddSubseason: componentDidMount');
		this.setProps(this.props);
 	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		//console.log('AddSubseason: UNSAFE_componentWillReceiveProps: ');
		//console.log(nextProps);
		this.setProps(nextProps);
	}

 	setProps(props) {
		var startDate = new Date();
  	startDate = moment(startDate).utc().format("YYYY-MM-DD");
  	this.setState({
  		seasonId: props.seasonId,
  		ssid: props.ssid,
   		startDate: startDate
  	});
 	}

	handleSubmit(e) {
		e.preventDefault();
		var _this = this;
	
		Axios.post('/api/seasons/subseason/add', {
			seasonObjId: _this.state.seasonId,
			subSeasonId: String(_this.state.ssid),
			subseasonName: _this.state.subseasonName,
			startDate: _this.state.startDate,
			divisions: [{
				name: 'Division par défaut',
				teams: []
			}]
		})
		.then(function(response) {
			console.log(response);

			const path = '/admsafe/season/subs';
			_this.props.history.push(path);
			_this.props.reloadSeason();
		})
		.catch(function(error) {
			console.log(error);
		});
	}
	
	render() {
		// console.log('AddSubseason: RENDER');
		//console.log(this.state.seasonId);

		return (
			<div className="row">
      <div className="col-md-12">
	      <form className="form-horizontal" onSubmit={this.handleSubmit}>
          <div className="row">
          <div className="col-md-12">
          <div className="form-group">
            <h5>Ajout d'une sous-saison</h5>
          	<div className="row">
						<div className="col-md-6">
							Nom <br/>
							<input type="text" className="form-control" id="subseasonName" 
								placeholder="(ex: Demie 1)" value={this.state.subseasonName || ''}
								onChange={this.handleSeasonNameChange} />
							<br/>
						</div>
						</div>

         	<div className="row">
					<div className="col-md-4">
						Date de début <br/>
						<input type="date" className="form-control" id="startDate" 
							placeholder="(ex: Demie 1)" value={this.state.startDate}
							onChange={this.handleStartDateChange} />
						<br/>

						<button type="submit" className="btn btn-primary">Ajouter la Sous-saison</button>
					</div>
					</div>

					</div>
					</div>
					</div>
				</form>
			</div>
 			</div>
    );
  }

  handleSeasonNameChange(e) {
  	var subseasonName = e.target.value;
  	this.setState({
		subseasonName: subseasonName
  	});
  }

  handleStartDateChange(e) {
  	var startDate = e.target.value;
  	this.setState({
		startDate: startDate
  	});
  }

}

export default AddSubseason;